import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_warehousing from "../../../assets/images/warehousing_icon.png";
import N_wws_fumigation from "../../../assets/images/fumignation_icon.png";
import N_wws_Procurement from "../../../assets/images/feild_icon.png";
import N_wws_Export from "../../../assets/images/export_assist_icon.png";
import ServiceContact from "../../../_Pages/_webapp/OurServises/ServiceContact";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";

class WweDevelopmentActors extends React.Component {
  render() {
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Arya serves development actors with collateral management, fumigation, on-field farmer procurement, and quality procurement. Contact us for more information.";

    return (
      <React.Fragment>
        <Helmet>
          <title>Who we Serve | Development Actors | Arya</title>
          <meta
            name="keywords"
            content="Warehouse near me, paddy warehouse, Maize Warehouse, Sugar warehouse, Wheat warehouse, Soyabean warehouse, Rice warehouse, Cotton warehouse, List your warehouse, Buy sell paddy online, Buy sell maize online, Buy sell pulses online, Buy sell spices online, Get loan on agri products, Get loan on agri commodities, Get finance on your commodities, paddy stock near me, maize Stock near me, Wheat stock near me, Bajra Stock near me, Jowar stock near me, Sugar stock near me, Soybean Stock near me, Cotton stock near me, Rice stock near me"
          />
        </Helmet>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>
        <section className="Whoweservebanner DA_Banner">
          <Container>
            <Row>
              <Col>
                <div className="wws_banner_portion">
                  <div className="wws_banner_heading">
                    <h1>
                      {localStorage.getItem("warehouseCount")
                        ? localStorage.getItem("warehouseCount") + "+"
                        : "9600+"}
                      <MultiLanguageTranslation title=" Warehouses Across " />
                      {localStorage.getItem("districtCount")
                        ? localStorage.getItem("districtCount") + "+"
                        : "800+"}
                      <MultiLanguageTranslation title=" Locations" />
                    </h1>
                  </div>
                  <div className="wws_banner_heading_content">
                    <a href="/WhoWeServeFPO">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Farmer & FPO" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Processor">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Processors" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Agri_corporation">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Agri Corporations" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Financial">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Financial Institutions" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/InternationalBuyer">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="International Buyers" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/DevelopmentActors">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Development Actors" />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="NA_customBreadcumb">
                <Link onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="Arya.ag" />
                </Link>{" "}
                <span>→</span>{" "}
                <Link onClick={() => this.props.history.push("/WhoWeServe")}>
                  <MultiLanguageTranslation title="Who We Serve" />
                </Link>{" "}
                <span>→</span>
                <span className="breadcrumb_active">
                  <MultiLanguageTranslation title="Development Actors" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <section className="N_wws">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="N_wws_heading">
                  <h2>
                    <MultiLanguageTranslation title="Development Actors" />
                  </h2>
                </div>
                <div className="wws_desc">
                  <p>
                    <MultiLanguageTranslation title="Development_Actors_page_Development_Actors_comprising" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="N_wws_offer_por">
          <Container>
            <Row>
              <Col>
                <div className="N_wws_offer">
                  <div className="N_wws_offer_heading">
                    <h4>
                      <MultiLanguageTranslation title="Our Offerings" />
                    </h4>
                  </div>
                  <div className="N_wws_offer_content-sec">
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_warehousing} />
                      <h5>
                        <MultiLanguageTranslation title="Collateral Management" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_fumigation} />
                      <h5>
                        <MultiLanguageTranslation title="Fumigation" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Procurement} />
                      <h5>
                        <MultiLanguageTranslation title="On Field Farmer Procurement" />{" "}
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Procurement} />
                      <h5>
                        <MultiLanguageTranslation title="Quality Procurement Assistance & Monitoring" />{" "}
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Export} />
                      <h5>
                        <MultiLanguageTranslation title="Consulting On Post Harvest Value Chain and Farm Linkages" />
                      </h5>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <ServiceContact />
        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}
export default WweDevelopmentActors;
